import React from 'react'
import './Btn.css';
const Btn = () => {
  return (
    <div>
         <button>KNOW MORE</button>
    </div>
  )
}

export default Btn